import React, { useEffect } from 'react';
import './formulario.css';

const Formulario = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div className='container formulario-container'>
        <div className='row'>
            <div className='col_12'>
                <div className='formulario_title'>
                    <h1>Registro de Empresa</h1>
                </div>
            </div>
        </div>
        <div className="row">
            <div className='texto'>
                <h6></h6>
            </div>        
        </div>
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScbosqBa-rKcVDQfqTaLhqpXtN8L4Ew-FJCX0fzU_AVhtf19Q/viewform" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                    width="100%" 
                    height="3350" 
                    frameborder="0" 
                    style={{border:0, marginBottom:50}} 
                    allowfullscreen>
            </iframe>

        


    </div>
  )
}   
export default Formulario